import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'

export default async function fetchFollows(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    convoUtils.convoService.getIsFollowed(convo).then((isFollowed: Meta<boolean>) => {
        convoStore.commitSetIsFollowed({ convo: convo, isFollowed: isFollowed.value })
    })

    return
}
